import { render, staticRenderFns } from "./BasicInfoEdit.vue?vue&type=template&id=64a70a8c&scoped=true&"
import script from "./BasicInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfoEdit.vue?vue&type=style&index=0&id=64a70a8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a70a8c",
  null
  
)

export default component.exports